import { render, staticRenderFns } from "./UtilMenu.vue?vue&type=template&id=1a4dd37e&scoped=true"
import script from "./UtilMenu.vue?vue&type=script&lang=js"
export * from "./UtilMenu.vue?vue&type=script&lang=js"
import style0 from "./UtilMenu.vue?vue&type=style&index=0&id=1a4dd37e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4dd37e",
  null
  
)

export default component.exports